import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { Button, Table } from "react-bootstrap";
import { Controller, useForm, useWatch } from "react-hook-form";
import Swal from "sweetalert2";

import { buttonIcon, buttonTypes } from "../../../../utils/buttonsUtil";
import { subWarehousesMap } from "../../../../utils/enumsUtil";

import Sidebar from "../../../../components/Navigation/Sidebar";
import Topbar from "../../../../components/Navigation/Topbar";
import Header from "../../../../components/Page/header";
import NumberInput from "../../../../components/Inputs/Text/Number";
import MultiFile from "../../../../components/Inputs/MultiFile";
import ScanOutboundManifest from "../../../../components/Modal/WMS/Transfers/Scan";
import SubmitButton from "../../../../components/Common/submitButton";

const WMSInboundTransfer = ({
    transferData,
    reduxResetTransferForInboundByManifestForm,
    requestingProcessTransferInbound,
    successfulProcessTransferInbound,
    errorsProcessTransferInbound,
    processTransferInboundResult,
    reduxResetInboundForm,
    reduxProcessInboundTransfer,
}) => {
    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        reset,
        watch,
        setValue,
    } = useForm({
        defaultValues: {
            idTransfer: transferData?.idTransfer,
            receiptDetails: [],
            files: [],
            comments: '',
        }
    });

    const history = useHistory();
    const userData = JSON.parse(window.localStorage.getItem('userData'));

    const [showScanModal, setShowScanModal] = useState(true);

    const filesWatcher = watch('files', [])

    useEffect(() => {
        if (!transferData) return;

        if (!userData.idHub) {
            Swal.fire(
                "No permitido",
                `Lo sentimos pero su usuario no está asociado a ningún HUB o el HUB no tiene asociada una bodega`,
                "error"
            );
            handleReset();
            history.goBack();
            return;
        }
    }, [])

    useEffect(() => {
        if (!transferData) return;

        reset({
            ...watch(),
            idTransfer: transferData.idTransfer,
            receiptDetails: transferData.products.map(item => {
                return {
                    idProduct: item.idProduct,
                    declaredQty: item.declaredQty,
                    availableStock: 0,
                    expiredStock: 0,
                    damagedStock: 0,
                    missingStock: 0,
                    surplusStock: 0,
                    supplantingStock: 0,
                }
            })
        });
    }, [transferData]);

    useEffect(() => {
        if (successfulProcessTransferInbound && processTransferInboundResult) {
            Swal.fire(
                "Proceso Exitoso",
                `${processTransferInboundResult?.message || 'Traslado procesado correctamente'}`,
                "success"
            ).then(() => {
                handleReset();
                history.goBack();
            });
        }
        if (errorsProcessTransferInbound && processTransferInboundResult) {
            Swal.fire(
                "Proceso Fallido",
                `${processTransferInboundResult?.message || 'Error al procesar el traslado'}`,
                "error"
            );
        }

    }, [successfulProcessTransferInbound, errorsProcessTransferInbound, processTransferInboundResult])

    const handleChangeFiles = (e) => {
        setValue('files', Array.from(e.target.files))
    }

    const handleRemoveFile = (index) => {
        const newFiles = filesWatcher.filter((_, i) => i !== index);
        setValue('files', newFiles)
    }

    const submitForm = (formData) => {
        const invalidLines = formData.receiptDetails.filter(item => {
            const total = subWarehousesMap.reduce((sum, { stocktype }) => sum + (Number(item[stocktype]) || 0), 0);
            return total === 0;
        });

        if (invalidLines.length > 0) {
            Swal.fire(
                "Información incompleta",
                "Debe registrar al menos una cantidad para cada producto. Por favor, asegúrese de registrar todos los productos.",
                "warning"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro de completar la recepción del traslado?",
            text: `Se registrarán las cantidades ingresadas para cada producto. ¿Desea continuar?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, completar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    idTransfer: transferData.idTransfer,
                    receiptDetails: formData.receiptDetails.map(item => ({
                        idProduct: item.idProduct,
                        availableQty: item.availableStock || 0,
                        expiredQty: item.expiredStock || 0,
                        damagedQty: item.damagedStock || 0,
                        missingQty: item.missingStock || 0,
                        extraQty: item.surplusStock || 0,
                        supplantedQty: item.supplantingStock || 0,
                    })),
                    // files: formData.files,
                    comments: formData.comments,
                }

                reduxProcessInboundTransfer(data);
            }
        });
    }

    const handleCloseScanModal = () => {
        setShowScanModal(false);

        if (!transferData) {
            handleReset();
            history.goBack();
        }
    }

    const handleReset = () => {
        reduxResetInboundForm();
        reduxResetTransferForInboundByManifestForm();
        reset();
    }

    const TotalProcessedCell = ({ control, index }) => {
        const values = useWatch({ control, name: `receiptDetails.${index}` });

        const total = subWarehousesMap.reduce((sum, { stocktype }) => sum + (Number(values?.[stocktype]) || 0), 0);

        return <NumberInput value={total} readOnly />

        // return (
        //     <>
        //         <NumberInput className={total > values.declaredQty ? 'is-invalid' : ''} value={total} readOnly />
        //         {
        //             total > values.declaredQty && (
        //                 <span className="text-danger">El total por línea no puede ser menor a la cantidad declarada.</span>
        //             )
        //         }
        //     </>
        // )
    };

    const actionButtons = [
        {
            onClick: () => {
                handleReset();
                history.goBack();
            },
            description: "Regresar a Movimientos",
            buttonType: buttonTypes.Primary,
            buttonIcon: buttonIcon.Arrow_LeftReply,
        },
    ];

    return (
        <>
            <div>
                <div id="wrapper">
                    <Sidebar />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topbar />
                            <div className="container-fluid">
                                <Header title={transferData?.transferNumber ? `Traslado ${transferData?.transferNumber}` : "Procesar Traslado"} actionButtons={actionButtons} />
                            </div>
                            <div className="card shadow mb-4">
                                <div className="card-body d-flex flex-column gap-1">
                                    <form onSubmit={handleSubmit(submitForm)}>
                                        <div className="table-responsive" style={{ maxHeight: '50vh' }}>
                                            <Table bordered hover className="mb-0">
                                                <thead className="table-light sticky-top">
                                                    <tr>
                                                        <th className="text-center">Producto</th>
                                                        <th className="text-center">Declarado</th>
                                                        {subWarehousesMap.map((t) => (
                                                            <th key={t.idType} className="text-center">{t.name}</th>
                                                        ))}
                                                        <th className="text-center">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transferData?.products?.map((item, index) => (
                                                        <tr key={item.idProduct}>
                                                            <td className="text-center align-middle">
                                                                {item.name}
                                                                <input type="hidden" {...register(`receiptDetails.${index}.idProduct`)} />
                                                            </td>
                                                            <td>
                                                                <input type="hidden" {...register(`receiptDetails.${index}.declaredQty`)} />
                                                                <NumberInput
                                                                    value={item.declaredQty}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            {subWarehousesMap.map((t) => (
                                                                <td key={t.idType}>
                                                                    <NumberInput
                                                                        {...register(`receiptDetails.${index}.${t.stocktype}`, {
                                                                            valueAsNumber: true,
                                                                            min: 0,
                                                                        })}
                                                                    />
                                                                </td>
                                                            ))}
                                                            <td>
                                                                <TotalProcessedCell control={control} index={index} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                        <div className="d-flex flex-column gap-1 mt-5">
                                            {/* <div className='form-group'>
                                                <Controller
                                                    control={control}
                                                    name="files"
                                                    render={() => (
                                                        <>
                                                            <label
                                                                htmlFor='files'
                                                                className='form-label'>
                                                                Evidencias
                                                            </label>
                                                            <MultiFile
                                                                files={filesWatcher}
                                                                tabIndex={16}
                                                                accept="image/*"
                                                                onChange={handleChangeFiles}
                                                                handleRemove={handleRemoveFile}
                                                            />
                                                        </>
                                                    )}
                                                />
                                            </div> */}
                                            <div className='form-group'>
                                                <label
                                                    htmlFor='comments'
                                                    className='form-label'>
                                                    Comentarios/Observaciones
                                                </label>
                                                <textarea
                                                    {...register('comments', {
                                                        required: 'El campo comentario es requerido'
                                                    })}
                                                    className={`form-control`}
                                                    type="textarea"
                                                    tabIndex={17}
                                                />
                                                {
                                                    errors.comments &&
                                                    <span className="error-message">
                                                        {errors.comments.message}
                                                    </span>
                                                }
                                            </div>
                                            <div className='d-flex justify-content-center'>
                                                <SubmitButton
                                                    variant='primary'
                                                    tabIndex={18}
                                                    type='submit'
                                                    text='Confirmar'
                                                    loading={requestingProcessTransferInbound}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScanOutboundManifest show={showScanModal} handleClose={handleCloseScanModal} />
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        transferData: state.wmsTransfersState.transferByOutboundManifest,
        requestingProcessTransferInbound: state.wmsTransfersState.requestingProcessTransferInbound,
        successfulProcessTransferInbound: state.wmsTransfersState.successfulProcessTransferInbound,
        errorsProcessTransferInbound: state.wmsTransfersState.errorsProcessTransferInbound,
        processTransferInboundResult: state.wmsTransfersState.processTransferInboundResult,
        hubData: state.branchState.rowEdited,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxCreateManifest: (payload) =>
            dispatch({
                type: "CREATE_MANIFEST_REQUEST",
                value: payload,
            }),
        reduxResetInboundForm: () =>
            dispatch({
                type: "RESET_TRANSFER_INBOUND_FORM",
            }),
        reduxResetTransferForInboundByManifestForm: () =>
            dispatch({
                type: "RESET_TRANSFER_FOR_INBOUND_BY_MANIFEST_FORM"
            }),
        reduxGetHub: (payload) =>
            dispatch({
                type: "READ_BRANCH_REQUEST",
                value: payload,
            }),
        reduxProcessInboundTransfer: (payload) =>
            dispatch({
                type: "PROCESS_TRANSFER_INBOUND_REQUEST",
                value: payload,
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WMSInboundTransfer);